<template>
    <div>
        <v-row justify="center">
           
            <v-col  class="py-2">
                <datePickerForm
                    label="Fecha"
                    :valueInput="values.date"
                    :rule="rules.required"
                    @valueChange="(v) => {values.date = v; delete serverErrors['date']}"
                    :errorMessages="serverErrors['date']"
                    data-cy="date-input"
                ></datePickerForm>
            </v-col>
        </v-row>
       

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Requisiciones"
                    :loading="loadingRequisitions"
                    :valueInput="values.requisition_id"
                    :rule="rules.required"
                    :items="serverItems.requisitions"
                    :errorMessages="serverErrors.requisition_id"
                    @valueChange="(v) => {values.requisition_id = v; getPurchaseOrderDetails(v); delete serverErrors.requisition_id; delete serverErrors.products}"
                    data-cy="requisition_id-input"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Proveedor"
                    :loading="loadingSupplier"
                    :valueInput="values.supplier_id"
                    :rule="rules.required"
                    :items="serverItems.suppliers"
                    :errorMessages="serverErrors.supplier_id"
                    :disabled="false"
                    @valueChange="(v) => {values.supplier_id = v; delete serverErrors.supplier_id}"
                    data-cy="supplier_id-input"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Divisa"
                    data-cy="foreign_exchange-input"
                    :valueInput="values.foreign_exchange"
                    :rule="rules.required"
                    :items="serverItems.currencies"
                    :errorMessages="serverErrors.foreign_exchange"
                    @valueChange="(v) => {values.foreign_exchange = v; delete serverErrors.foreign_exchange}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="" >
                <checkboxForm
                    label="Esta compra se paga a parcialidades"
                    :valueInput="values.has_installments"
                    
                    @valueChange="(v) => {values.has_installments = v; delete serverErrors[`has_installments`];}"
                    :errorMessages="serverErrors[`has_installments`]"
                    data-cy="has_installments-input"
                ></checkboxForm>
            </v-col>
        </v-row>

        <v-row class="py-1" align="center" justify="space-between">
            <v-col class="py-1" cols="12" >
                <div class="d-flex">
                    <textAreaForm 
                        @valueChange="(v) => {values.comments = v; delete serverErrors.comments}" 
                        :valueInput="values.comments" 
                        label="Comentarios"
                        :errorMessages="serverErrors.comments"
                        data-cy="comments-input"
                    ></textAreaForm>
                    
                    <RequisitionTableActions
                        :itemInput="{actions: values.actionComments, localMessages: values.localComments}"
                        :parameters="{}"
                        :edit="true"
                        @methodHandler="method_handler"
                        :nudgeLeft="7"
                        :show="true"
                        customTitle="Comentarios"
                        :xLarge="true"
                    ></RequisitionTableActions>
                </div>
                
            </v-col>
            
        </v-row>


        <!-- <v-row>
            <v-col class="py-2">
                <fileInputForm
                    
                    label="Subir imágen"
                    :multiple="false"
                    :valueInput="values.invoice"
                    :url="values.invoice_path"
                    :rule="[]"
                    @valueChange="(v) => {values.invoice = v; delete serverErrors.invoice}"
                    :errorMessages="serverErrors.invoice"
                    v-on:update:url="values.invoice_path = $event"
                    data-cy="invoice-input"
                ></fileInputForm>
            </v-col>
        </v-row> -->

          

        <v-row justify="center">
            <v-col class="pt-3 pb-0 font-weight-bold body-2 mb-0" >
                <p class="mb-0 pb-0">Insumos</p>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2" cols="12">
               <div class="purchaseOrder-select-products-container">
                <autocompleteOneForm
                    label="Insumo"
                    :loading="loadingProducts"
                    :valueInput="productSelected"
                    :rule="[]"
                    :items="serverItems.products"
                    :returnObject="true"
                    data-cy="productSelected-input"
                    @valueChange="(v) => {productSelected = v;}"
                    class="width-available mr-3"
                    :disabled="true"
                ></autocompleteOneForm>
                <iconButton
                    data-cy="productSelected-input-btn"
                    :props="{
                    color:'primary',
                    icon:'mdi-plus',
                    height:'41',
                    click: () => {addProduct()}
                    }"
                ></iconButton>
               </div>
            </v-col>
            <v-col class="py-2">
                
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <table-items data-cy="table-items" :props="tableProps" @methodHandler="method_handler" :items="values.products">
                    
                    <template v-slot:item.quantity="props" >

                        <div class="table-item">
                            <textFieldForm 
                                @valueChange="(v) => {props.item.quantity = v;updateItem(props.item); delete serverErrors.products}" 
                                :valueInput="props.item.quantity" 
                                :rule="[...rules.quantity]" 
                                data-cy="table-quantity-input"
                                
                            ></textFieldForm>
                        </div>
                    </template>

                    <template v-slot:item.amount="props" >

                        <div class="table-item">
                            <textFieldForm 
                                @valueChange="(v) => {props.item.amount = v; updateItem(props.item); delete serverErrors.products}" 
                                :valueInput="props.item.amount" 
                                :rule="[...rules.amount]" 
                                data-cy="table-amount-input"
                                
                            ></textFieldForm>
                        </div>
                    </template>

                    <template v-slot:item.actions="item" >

                        <RequisitionTableActions
                            :itemInput="item.item"
                            :parameters="item.parameters"
                            :edit="false"
                            @methodHandler="method_handler"
                            :nudgeLeft="7"
                        ></RequisitionTableActions>



                      
                    </template>


                    <!-- <template v-slot:item.subtotal="props" >

                        <div class="table-item">
                            {{Utils.currencyFormat(props.item.subtotal, "")}}
                        </div>
                    </template> -->
                    
                </table-items>
                
            </v-col>
           
        </v-row>
        <span class="red--text caption" v-if="serverErrors[`products`]">{{serverErrors[`products`]}}</span>
      

        
       

    </div>
</template>

<script>
import Utils from '../../../helpers/Utils';
import RequisitionTableActions from '../requisitions/RequisitionTableActions.vue';
/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit', 'reqId'],
    components:{
        // ImageSlide
        RequisitionTableActions
    },
    data(){
        return {
           
            ut: new Utils(),
            loadingRequisitions: false,
            loadingSupplier: false,
            loadingProducts:false,
            loadingReqData:false,
            productSelected: {},

            actions: [
				{
					name: 'Descripciones',
					icon: {
						color: 'secondary',
						icon: 'mdi-message-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openComments',
                    dataCy: "descriptions-link"
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItem',
                    dataCy: "delete-link"
				},
			],
            tableProps: {
				headers: [
                     {
						text: 'Insumo',
						align: 'left break-words',
						value: 'name',
                        
						class: 'table-b-border black--text',
                        sortable: false,
					},
					
                    {
						text: 'Cantidad',
						align: 'center',
						value: 'quantity',
						sortable: false,
                        width: "15%",
						class: 'table-b-border black--text'
					},
                    {
						text: 'Importe',
						align: 'center',
						value: 'amount',
						sortable: false,
                        width: "15%",
						class: 'table-b-border black--text'
					},

                    {
						text: 'Subtotal',
						align: 'center',
						value: 'subtotal',
						sortable: false,
						class: 'table-b-border black--text'
					},
                   
					{
						text: '',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
			},
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
                
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,2})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],

                quantity: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],
				
				
            },

            serverItems:{
               
                requisitions: [],
                suppliers: [],
                products: [],
                currencies: [
                    {value:"mxn", text:"Peso mexicano (MXN)" },
                    {value:"usd", text:"Dólar estadounidense (USD)" },
                ]
            }
            

          
        }
    },
    watch: {
        [`values.foreign_exchange`](v) {
            this.values.products = this.values.products.map((item,i) => {
                
                item.subtotal =  this.getSubtotal(item.quantity, item[`price_${v}`]);
                item.amount = item[`price_${v}`];
                return item;
            })
            
        }
    },
   
    mounted(){
        console.log(this.values, "req id");
        this.getRequisitions();
        this.getSuppliers();
        this.getSupplies();
        if(this.edit){
            // this.getProducts(this.values.supplier_id) 
            this.loadProducts();
            this.loadGeneralComments();
        }

        if(this.reqId != undefined && this.reqId != null){
            this.values.foreign_exchange = "mxn"
            this.loadRequisitionData();
        }
    },
    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        loadGeneralComments()
        {
            this.values.actionComments = JSON.parse(JSON.stringify(this.actions)).filter((x) => x.action == 'openComments');
            this.values.actionComments[0].name = "Comentarios";
            this.values.actionComments[0].icon.color = "gray";
        },
        loadRequisitionData(){
            this.loadingReqData = true;
            this.$api.requisition.toPurchaseOrder(this.reqId)
                .then((resp) => {
                    console.log(resp.data, "response")
                    this.values.requisition_id = this.reqId

                    this.values.products = resp.data.supplies.map((item,i) => {
                        // x['parameters'] = { id: x.slug, name: x.sku, index: i};
                        
                        item.subtotal =  this.getSubtotal(item.quantity, item.price_mxn);

                    
                        return {
                            actions: JSON.parse(JSON.stringify(this.actions)),
                            parameters: { id: item.supply_id, name: item.supply, index: i},
                            localMessages: [...item?.comments?.map((ms) => {return{...ms, isNew:false}})??[]],
                            comments: item?.comments??'',
                            supply_id: item.supply_id,
                            subtotal: this.getSubtotal(item.quantity, item.price_mxn),
                            amount: item.price_mxn,
                            name: item.supply,
                            quantity : item.quantity,
                            price_mxn: item.price_mxn,
                            price_usd: item.price_usd
                        }
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingReqData = false;
                })
            ;
        },
        getSupplies()
        {
            this.loadingProducts = true;
            this.$api.supply.getSupplies()
                .then((resp) => {
                    this.serverItems.products = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingProducts = false;
                })
            ;
          
        },
        loadProducts()
        {
            console.log("loadproducts runnnnn")
            this.values.products = this.values.products.map((item,i) => {
                // x['parameters'] = { id: x.slug, name: x.sku, index: i};
                
                item.subtotal =  this.getSubtotal(item.quantity, item.amount);

               
                return {
                    actions: JSON.parse(JSON.stringify(this.actions)),
                    parameters: { id: item.supply_id, name: item.supply, index: i},
                    localMessages: [...item?.comments?.map((ms) => {return{...ms, isNew:false}})??[]],
                    comments: '',
                    supply_id: item.supply_id,
                    subtotal: this.getSubtotal(item.quantity, item.amount),
                    amount: item.amount,
                    name: item?.name??item.supply,
                    quantity : item.quantity,
                    price_mxn: item.amount,
                    price_usd: item.amount
                }
            })
        },
        addProduct()
        {
            console.log(this.values)
            if(!("value" in this.productSelected))
                return;

            let found = this.values.products.find(fItem => fItem.supply_id == this.productSelected.value)
            if(found != undefined)
                return;

            let item = this.productSelected;
            let newProd = {
                actions: JSON.parse(JSON.stringify(this.actions)),
                parameters: { id: item.value, name: item.text, index: 99},
                supply_id: item.value,
                subtotal: this.getSubtotal(1, 1),
                amount: 1, //item.amount.replace(",",""),
                name: item.text,
                quantity : 1,
                price_mxn: 1,
                price_usd: 1
            }

            this.values.products.push(newProd);

            this.values.products = this.values.products.map((item,i) => {
                // x['parameters'] = { id: x.slug, name: x.sku, index: i};
                return {
                    ...item,
                    parameters: { id: item.supply_id, name: item.product, index: i},
                    
                }
            })
            
        },
        getSubtotal(quantity = 0, amount = 0)
        {
            let subtotal = quantity * amount;

            if(isNaN(subtotal))
                subtotal = 0;
            return Utils.currencyFormat(subtotal, "");
        },
        updateItem(item)
        {
            item.subtotal = this.getSubtotal(item.quantity, item.amount)

           
        },
        getRequisitions()
        {
            this.loadingRequisitions = true;
            this.$api.requisition.getSelect()
                .then((resp) => {
                    this.serverItems.requisitions = resp.data.reverse();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingRequisitions = false;
                })
            ;
        },

        getSuppliers()
        {
            this.loadingSupplier = true;
            this.$api.supplier.getSelect()
                .then((resp) => {
                    this.serverItems.suppliers = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingSupplier = false;
                })
            ;
        },


        getPurchaseOrderDetails(sku)
        {
            this.productSelected = {}
            if(sku === "")
                return;

            this.values.products = [];
            this.loadingDetails = true;
            this.$api.requisition.getDetails(sku)
                .then((resp) => {

                    this.values.products = resp.data.map((item,i) => {
                        // x['parameters'] = { id: x.slug, name: x.sku, index: i};
                        return {
                            actions: JSON.parse(JSON.stringify(this.actions)),
                            localMessages: [...item?.comments?.map((ms) => {return{...ms, isNew:false}})??[]],
                            comments: '',
                            parameters: { id: item.supply_id, name: item.supply, index: i},
                            supply_id: item.supply_id,
                            subtotal: 0,
                            amount: 0,
                            name: item?.name??item.supply,
                            quantity : item.quantity,
                            price_mxn: 0,
                            price_usd: 0
                        }
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingDetails = false;
                })
            ;
        },

        deleteItem(item)
        {
            console.log(item, "delte item")
            // this.values.products.splice(item.index, 1);
            let index = this.values.products.findIndex(prod => prod.supply_id == item.id);

            console.log(index, item);
            this.values.products.splice(index, 1);
        },

        getProducts(supplier)
        {
            if(supplier == "" || supplier == null || supplier == undefined)
                return;

            this.loadingProducts = true;
            this.$api.supplier.getProducts(supplier)
                .then((resp) => {
                    this.serverItems.products = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingProducts = false;
                })
            ;
        },


        scrollToEnd: function () {
            // scroll to the start of the last message
            try {
                this.$refs.listChat[0].scrollTop = this.$refs.listChat[0].lastElementChild.offsetTop;
            } catch (error) {
                console.log(error);
            }
        },
        tobottom () {
            try {
                this.$refs.listChat[0].scrollTop = this.$refs.listChat[0].lastElementChild.offsetTop;
            } catch (error) {
                console.log(error);
            }
        },

        openComments(item){
            console.log(this.$refs.listChat)
            try {
                setTimeout(() => {
                    this.tobottom();
                    
                }, 100);
            } catch (error) {
                
            }

            return true;
        },
        closeItem(item){
            item.menu = false;
        },
        addComments(item){
            if(this.comment == "")
                return;
            // console.log(item, "add cooment")
            // this.values.localMessages = 
            item.comments = JSON.parse(JSON.stringify(this.comment));
            if(this.edit){
                item.localMessages.push({
                    comments: item.comments,
                    date:  Utils.getNowDate(),
                    position: "right",
                    user: this.$store.state.loggedUsername,
                })
            }else{
                item.localMessages = [
                    {
                        comments: item.comments,
                        date:  Utils.getNowDate(),
                        position: "right",
                        user: this.$store.state.loggedUsername,
                    }
                ];
            }


            this.comment = "";
            this.messagesWindowKey = this.messagesWindowKey + 1;
            item.menu = false;
            console.log(item, "completo")
        },
       
    }
}
</script>

<style lang="scss">
    .purchaseOrder{

        &-select-products-container{
            display: flex;
        }
    }
</style>